export const STRIPE_PAYMENT_TYPE_ID = 'stripe';

// unable to auto collect fees by platform 
export const PAYPAL_PAYMENT_TYPE_ID = 'paypal';
export const CASH_PAYMENT_TYPE_ID = 'cash';
export const CARD_TERMINAL_PAYMENT_TYPE_ID = 'cardTerminal';